import React, { useState } from "react";
import {
  Notifications,
  People,
  School,
  Computer,
  Map,
  List as ListIcon,
} from "@mui/icons-material";

import "../../../styles/pages/homePage/ouLinks.scss";

const OuLinks = () => {
  const [searchQuery, setSearchQuery] = useState("");

  const internalSystems = [
    {
      title: "AIMS",
      link: "https://our.upou.edu.ph/login",
      shortDescription: "Academic Information Management System",
      fullDescription: "Academic records and information management system",
      icon: <Notifications fontSize="large" />,
    },
    {
      title: "UPOU URL Shortener",
      link: "https://url.upou.edu.ph",
      shortDescription: "URL Shortening Service",
      fullDescription:
        "Create and manage short URLs for UPOU-related links and resources.",
      icon: <ListIcon fontSize="large" />,
    },
    {
      title: "MyPortal",
      link: "https://myportal.upou.edu.ph/",
      shortDescription: "UPOU's Learning Management System",
      fullDescription: "UPOU’s official learning management system",
      icon: <School fontSize="large" />,
    },
    {
      title: "HRDO System",
      link: "https://sites.google.com/a/upou.edu.ph/upou-human-resources-development-office/",
      shortDescription: "Staff Portal: information and forms",
      fullDescription: "HR forms and staff information system",
      icon: <People fontSize="large" />,
    },
    {
      title: "Workspace",
      link: "https://workspace.upou.edu.ph",
      shortDescription: "UPOU Workspace",
      fullDescription: "UPOU’s internal collaboration platform",
      icon: <Computer fontSize="large" />,
    },
    {
      title: "ICTDO Support",
      link: "mailto:techsupport@upou.edu.ph",
      shortDescription: "Get technical support from ICTDO.",
      fullDescription: "ICTDO technical support services",
      icon: <Computer fontSize="large" />,
    },

    {
      title: "Faculty of Education",
      link: "http://fed.upou.edu.ph",
      shortDescription: "FEd Microsite",
      fullDescription: "Faculty of Education site",
      icon: <School fontSize="large" />,
    },
    {
      title: "Faculty of Information and Communication Studies",
      link: "http://fics.upou.edu.ph",
      shortDescription: "FICS Microsite",
      fullDescription: "Faculty of Information and Communication Studies site",
      icon: <School fontSize="large" />,
    },
    {
      title: "Faculty of Management and Development Studies",
      link: "http://fmds.upou.edu.ph",
      shortDescription: "FMDS Microsite",
      fullDescription: "Faculty of Management and Development Studies site",
      icon: <School fontSize="large" />,
    },
    {
      title: "ICTDO",
      link: "http://ictdo.upou.edu.ph",
      shortDescription: "ICTDO Microsite",
      fullDescription: "ICTDO information and resources",
      icon: <Computer fontSize="large" />,
    },
    {
      title: "Office of Gender Concerns",
      link: "http://ogc.upou.edu.ph",
      shortDescription: "OGC Microsite",
      fullDescription: "Office of Gender Concerns site",
      icon: <People fontSize="large" />,
    },
    {
      title: "Office of Student Affairs",
      link: "http://osa.upou.edu.ph",
      shortDescription: "OSA Microsite",
      fullDescription: "Office of Student Affairs site",
      icon: <People fontSize="large" />,
    },
    {
      title: "Office of the Vice Chancellor for Academic Affairs",
      link: "http://ovcaa.upou.edu.ph",
      shortDescription: "OVCAA Microsite",
      fullDescription:
        "Office of the Vice Chancellor for Academic Affairs site",
      icon: <School fontSize="large" />,
    },
    {
      title: "OVCFA Microsite",
      link: "http://ovcfa.upou.edu.ph",
      shortDescription: "OVCFA Website",
      fullDescription:
        "Office of the Vice Chancellor for Finance and Administration site",
      icon: <School fontSize="large" />,
    },
    {
      title: "CODTL",
      link: "https://codtl.upou.edu.ph",
      shortDescription: "Center for Open and Distance Teaching and Learning",
      fullDescription: "Center for Open and Distance Teaching and Learning",
      icon: <School fontSize="large" />,
    },
    {
      title: "The Ugnayan ng Pahinungód",
      link: "http://pahinungod.upou.edu.ph",
      shortDescription: "Pahinungód Microsite",
      fullDescription: "Ugnayan ng Pahinungód site",
      icon: <People fontSize="large" />,
    },
    {
      title: "University Library",
      link: "http://library.upou.edu.ph",
      shortDescription: "UPOU Library",
      fullDescription: "Internal URL shortening tool",
      icon: <ListIcon fontSize="large" />,
    },

    {
      title: "Cash Office",
      link: "https://cashoffice.upou.edu.ph",
      shortDescription: "Financial Services Portal",
      fullDescription: "Access to financial services and forms",
      icon: <ListIcon fontSize="large" />,
    },
    {
      title: "DTS",
      link: "https://dts.upou.edu.ph",
      shortDescription: "Document Tracking System",
      fullDescription: "Document tracking system",
      icon: <ListIcon fontSize="large" />,
    },

    {
      title: "iPortal",
      link: "https://iportal.upou.edu.ph",
      shortDescription: "Password Manager",
      fullDescription: "Password and account management tool",
      icon: <School fontSize="large" />,
    },
    {
      title: "ASCEND",
      link: "https://ascend.upou.edu.ph",
      shortDescription:
        "UPOU's official platform for the UPOU Microcredentials and Continuing Education Program (CEP)",
      fullDescription: "Platform for microcredentials and continuing education",
      icon: <School fontSize="large" />,
    },
    {
      title: "EXTEND",
      link: "https://extend.upou.edu.ph",
      shortDescription: "Extension Platform",
      fullDescription: "UPOU’s extension programs platform",
      icon: <School fontSize="large" />,
    },
    {
      title: "BAC Meeting",
      link: "https://bac.upou.edu.ph",
      shortDescription: "Bids and Awards Committee",
      fullDescription: "Bids and Awards Committee portal",
      icon: <People fontSize="large" />,
    },
    {
      title: "FICS Online Repository",
      link: "http://repository.upou.edu.ph",
      shortDescription: "FICS Repository",
      fullDescription: "Repository of academic resources from FICS",
      icon: <ListIcon fontSize="large" />,
    },
    {
      title: "Gate Sticker Request",
      link: "https://gatesticker.upou.edu.ph",
      shortDescription: "Vehicle Gate Pass System",
      fullDescription: "Vehicle gate pass application system",
      icon: <Map fontSize="large" />,
    },
    {
      title: "IREC Microsite",
      link: "http://irec.upou.edu.ph",
      shortDescription: "IREC Website",
      fullDescription: "Institutional Research Ethics Committee site",
      icon: <School fontSize="large" />,
    },
    {
      title: "JMDS Microsite",
      link: "http://jmds.upou.edu.ph",
      shortDescription: "Journal of Management and Development Studies",
      fullDescription: "Journal of Management and Development Studies site",
      icon: <ListIcon fontSize="large" />,
    },
    {
      title: "KAYA",
      link: "https://kaya.upou.edu.ph",
      shortDescription: "UPOU's Mental Health & Wellness Platform",
      fullDescription: "Mental health and wellness platform",
      icon: <School fontSize="large" />,
    },
    {
      title: "Sustainable Development Goals",
      link: "http://sdg.upou.edu.ph",
      shortDescription: "SDG Website",
      fullDescription: "UPOU’s Sustainable Development Goals site",
      icon: <ListIcon fontSize="large" />,
    },
    {
      title: "DRRM",
      link: "https://drrm.upou.edu.ph",
      shortDescription: "Disaster Risk Reduction and Climate Change Adaptation and Mitigation (DRR-CCAM)",
      fullDescription: "",
      icon: <Map fontSize="large" />,
    },
  ];

  const pinnedItems = internalSystems.slice(0, 5);
  // Sort remaining alphabetically
  const sortedRemaining = internalSystems
    .slice(5)
    .sort((a, b) => a.title.localeCompare(b.title));

  // Combine
  const orderedSystems = [...pinnedItems, ...sortedRemaining];

  // Apply search AFTER reordering
  const filteredSystems = orderedSystems.filter(
    (system) =>
      system.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      system.shortDescription
        .toLowerCase()
        .includes(searchQuery.toLowerCase()) ||
      system.fullDescription.toLowerCase().includes(searchQuery.toLowerCase())
  );
  // const filteredSystems = internalSystems.filter(
  //   (system) =>
  //     system.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
  //     system.shortDescription
  //       .toLowerCase()
  //       .includes(searchQuery.toLowerCase()) ||
  //     system.fullDescription.toLowerCase().includes(searchQuery.toLowerCase())
  // );

  return (
    // <div className="internal-systems">
    //   <div className="section-header">
    //     <input
    //       type="text"
    //       placeholder="Search UPOU Systems..."
    //       value={searchQuery}
    //       onChange={(e) => setSearchQuery(e.target.value)}
    //       className="search-input"
    //     />
    //   </div>
    //   <div className="quick-links">
    //     {filteredSystems.map((system, index) => (
    //       <a
    //         key={index}
    //         href={system.link}
    //         className="quick-link-item"
    //         target="_blank"
    //         rel="noopener noreferrer"
    //       >
    //         <div className="icon-container">
    //           <div className="icon">{system.icon}</div>
    //         </div>
    //         <div className="link-content">
    //           <span className="title">{system.title}</span>
    //           <span className="description">{system.shortDescription}</span>
    //           <div className="tooltip">{system.fullDescription}</div>
    //         </div>
    //       </a>
    //     ))}
    //   </div>
    // </div>

    <div className="internal-systems">
      <div className="section-header">
        <input
          type="text"
          placeholder="Search UPOU Systems..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="search-input"
        />
      </div>
      {/* <div className="quick-links">
        {filteredSystems.map((system, index) => (
          <a
            key={index}
            href={system.link}
            className="quick-link-item"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="icon-container">
              <div className="icon">{system.icon}</div>
            </div>
            <div className="link-content">
              <span className="title">{system.title}</span>
              <span className="description">{system.shortDescription}</span>
              <div className="tooltip">{system.fullDescription}</div>
            </div>
          </a>
        ))}
      </div> */}

      <div className="quick-links">
        {filteredSystems.map((system, index) => {
          const isPinned = index < 5;
          return (
            <a
              key={index}
              href={system.link}
              className="quick-link-item"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="icon-container">{system.icon}</div>
              <div className="link-content">
                {isPinned && (
                  <span className="most-used-badge">★ Most Used</span>
                )}
                <span className="title">{system.title}</span>
                <span className="description">{system.shortDescription}</span>
              </div>
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default OuLinks;
